import InputAdornment from "@mui/material/InputAdornment";
import TextField from "@mui/material/TextField";
import React from "react";

const CTextField = ({
  label,
  value,
  onChange,
  error,
  helperText,
  placeholder,
  showIcon,
  startIcon,
  endIcon,
  multiline = false,
  minRows = 1, // Minimum rows for multiline
  maxRows = 10, // Maximum rows for multiline
  variant = "outlined",
  handleKeyDown,
  disabled,
  textFieldPrefix,
  ...props
}) => {
  // MUI disallows minRows/maxRows when a fixed `rows` prop is set
  const hasFixedRows = props.rows != null;

  return (
    <TextField
      className={
        multiline
          ? "CTextarea !text-blue-500 !font-[Poppins]"
          : "lg:!mt-5 !mt-4 custom-input !text-blue-500 !font-[Poppins]"
      }
      label={label}
      value={value}
      onChange={onChange}
      error={error}
      placeholder={placeholder}
      helperText={helperText}
      variant={variant}
      onKeyDown={handleKeyDown}
      multiline={multiline && multiline}
      minRows={multiline && !hasFixedRows ? minRows : undefined}
      maxRows={multiline && !hasFixedRows ? maxRows : undefined}
      {...props}
      InputProps={{
        startAdornment: (
          <>
            {textFieldPrefix && (
              <span className="absolute left-2">{textFieldPrefix}</span>
            )}
            {startIcon ? (
              <InputAdornment position="start">{startIcon}</InputAdornment>
            ) : null}
          </>
        ),
        endAdornment: endIcon ? (
          <InputAdornment position="end">{endIcon}</InputAdornment>
        ) : null,
      }}
      InputLabelProps={{
        shrink: true,
      }}
      disabled={disabled}
    />
  );
};

export default CTextField;
